import { useCallback } from 'react';

import { fetchEndpointData } from 'api';
import type { VariantId } from 'models/product';
import { ignorePromiseRejection } from 'utils/helpers';

export function useTrackEvent() {
	const sendProductClickEvent = useCallback(
		(variantId: VariantId | undefined) => {
			if (variantId) {
				ignorePromiseRejection(
					fetchEndpointData({
						name: 'PostTrackEvent',
						queryParams: { eventType: 'ProductClickEvent', value: variantId },
					}),
				);
			}
		},
		[],
	);

	return { sendProductClickEvent };
}
